import { useIntl } from 'react-intl'
import './TechnicalIssuesMessage.scss'

// Flip to false and redeploy once the outage is over.
const SHOW_TECHNICAL_ISSUES_MESSAGE = false

// Red outage notice shown on login and start pages.
const TechnicalIssuesMessage = () => {
	const intl = useIntl()

	if (!SHOW_TECHNICAL_ISSUES_MESSAGE) {
		return null
	}

	return (
		<div className="TechnicalIssuesMessage">
			{intl.formatMessage({ id: 'client.start.technicalIssues' })}
		</div>
	)
}

export default TechnicalIssuesMessage
